import { getDownloadURL, ref, type FirebaseStorage, uploadBytes } from "firebase/storage";

export async function copyFile({
  oldPath,
  newPath,
  storage,
}: {
  oldPath: string;
  newPath: string;
  storage: FirebaseStorage;
}) {
  const fileBlob = await downloadFile(oldPath, storage);
  await uploadFile(fileBlob, newPath, storage);
}

async function downloadFile(filePath: string, storage: FirebaseStorage) {
  const fileRef = ref(storage, filePath);
  const url = await getDownloadURL(fileRef);
  const response = await fetch(url);
  const blob = await response.blob();
  return blob;
}

async function uploadFile(blob: Blob, newFilePath: string, storage: FirebaseStorage) {
  const newFileRef = ref(storage, newFilePath);
  await uploadBytes(newFileRef, blob);
}
